// extracted by mini-css-extract-plugin
module.exports =  {"container":"JZguG75fuEz_2rxUmvRQ","noProjectText":"RRrMhYfIOfk5x6nQd65F"};